import React, { FC } from 'react';

import StyledGrain from './styled';

const Grain: FC = () => <StyledGrain className="grain" />;

export default Grain;
